/* eslint-disable object-curly-newline */
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import Media from 'react-media';
import { useLocation } from 'react-router-dom';
import { Layout } from '../../contexts/LayoutContext';
import CreateAccountForm from './components/Form';
import PiperPresentation from '../CreateAccount/components/PiperPresentation';
import mediaQueries from '../../utils/mediaQueries';
import { container } from '../../styled/mixins';
import PromoCodeContainer from '../../components/becomePro/PromoCodeContainer';
import GlobalTheme from '../../styled/GlobalTheme';
import FacebookButton from '../auth/components/FacebookButton';
import PromoCodeContext from '../../contexts/PromoCodeContext';
import AppleButton from '../auth/components/AppleButton';
import roles from '../../utils/constants/roles';

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 740px;
  ${GlobalTheme.breakpoints.down('sm')} {
    margin-left: 15px;
    margin-right: 15px;
    width: 90%;
  }
  ${GlobalTheme.breakpoints.down('xs')} {
    margin-left: 15px;
    margin-right: 15px;
    width: 90%;
  }
`;

const LegalAccept = styled.div`
  margin-top: 50px;
  font-size: 16px;
  color: ${(props) => props.theme.colors.text02};
  text-align: center;
  ${GlobalTheme.breakpoints.down('sm')} {
    margin-left: 15px;
    margin-right: 15px;
  }
`;

const LegalLink = styled.a`
  color: ${(props) => props.theme.colors.lightBlue};
  text-decoration: underline;
`;

const Container = styled.div`
  ${container};
  padding-top: 54px;
  padding-bottom: 16px;
  ${GlobalTheme.breakpoints.down('sm')} {
    padding-left: 0;
    padding-right: 0;
  }
`;

const MainGrid = styled.div`
  width: 100%;
  display: grid;
  grid-gap: ${(props) => props.theme.space * 4}px;
  grid-template-columns: 245px 1fr;
  ${GlobalTheme.breakpoints.down('md')}{
    grid-template-columns: 1fr;
  }
`;

const ContainerSignUp = styled.div`
  width: 100%; 
  display: flex;
  ${GlobalTheme.breakpoints.up('lg')}{
    flex-direction: row;
  }

  ${GlobalTheme.breakpoints.up('md')}{
    flex-direction: row;
  }
  ${GlobalTheme.breakpoints.down('md')}{
    flex-direction: column;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    flex-direction: column;
  }
`;

const ContainerSignUpFields = styled.div`
  width: 100%;
  margin-right: 20px;
  ${GlobalTheme.breakpoints.down('sm')}{
    margin-right: 0;
  }
`;

const ContainerSignUpOptions = styled.div`
  width: 100%;
  border-left : 1px solid #909090;
  margin-left: 20px;
  ${GlobalTheme.breakpoints.down('lg')}{
    width: 60%;
    border-left : 0;
    margin-left: auto;
    margin-right: auto;
  }
  ${GlobalTheme.breakpoints.down('md')}{
    width: 100%;
    border-left : 0;
    margin-left: auto;
    margin-right: auto;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

const ButtonContainerSN = styled.div`
  text-align: center;
  margin: auto;
  width: 70%;
  margin-bottom: 20px;
  margin-top: 20px;
  ${GlobalTheme.breakpoints.down('md')}{
    width: 40%;
  }
  ${GlobalTheme.breakpoints.down('sm')}{
    width: 55%;
  }
  ${GlobalTheme.breakpoints.down('xs')}{
    width: 75%;
  }
`;

const TtileSignup = styled.div`
  font-size: 36px;
  font-weight: 600;
  width: 100%;
  padding-bottom: 20px;
  ${GlobalTheme.breakpoints.down('sm')}{
    font-size: 30px;
  }
`;

const TextSignupWith = styled.div`
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  ${GlobalTheme.breakpoints.down('sm')}{
    padding-top: 50px;
  }
`;

const LineSeparator = styled.div`
  width: 100%;
  border-bottom: 1px solid #909090;
  padding-bottom: 30px;
  margin-bottom: 30px;
  display: ${({ show }) => (show ? 'block;' : 'none;')};
`;

const ContainerCode = styled.div`
  display: ${({ show }) => (show ? 'contents;' : 'none;')};
  border: 1px solid red;
`;

const CreateAccount = () => {
  const intl = useIntl();
  const location = useLocation();
  const { PromoCode, handlePromoCodeChange, promoLock } = useContext(PromoCodeContext);
  const [planSelected, setPlanSelected] = useState('P');
  const [codeURL, setCodeURL] = useState('');
  const [wantsFree, setWantsFree] = useState(false);
  const [currentPlan, setcurrentPlan] = useState('');

  useEffect(() => {
    let plan = window.localStorage.getItem('planSelected');
    const code = window.localStorage.getItem('promoCode');
    const query = new URLSearchParams(location.search);

    if (code) {
      setCodeURL(code);
    }
    setPlanSelected((plan === roles.PRO || plan === roles.BASIC));
    if (query.get('plan')) {
      plan = query.get('plan');
      setPlanSelected((query.get('plan') === roles.PRO || query.get('plan') === roles.BASIC));
    }
    setcurrentPlan(plan);
    setWantsFree(plan === roles.BASIC);
  }, [PromoCode]);
  return (
    <Media queries={mediaQueries}>
      {(matches) => (
        <Layout
          title={intl.formatMessage({ id: 'onboarding.createAccount.title', defaultMessage: 'Create your account' })}
          description={intl.formatMessage({ id: 'onboarding.createAccount.description', defaultMessage: 'Start your 30-day free trial.' })}
          accessOnTrialEnds
        >
          <Container>
            <MainGrid>
              {(matches.lg || matches.lgUp) && (
                <PiperPresentation position="top" />
              )}
              <ContentSection>
                <TtileSignup>
                  <FormattedMessage
                    id="signup.createAccount.title"
                    defaultMessage="Create your account"
                  />
                </TtileSignup>
                <ContainerCode show={currentPlan === 'P'}>
                  <PromoCodeContainer
                    promoCode={PromoCode}
                    isLoading={promoLock}
                    onChangeHandler={handlePromoCodeChange}
                    codeURL={codeURL}
                  />
                </ContainerCode>

                <LineSeparator show={currentPlan === 'P'} />

                <ContainerSignUp>
                  <ContainerSignUpFields>
                    <CreateAccountForm
                      wantsFree={wantsFree}
                      planSelected={planSelected}
                    />
                  </ContainerSignUpFields>
                  <ContainerSignUpOptions>
                    <TextSignupWith>
                      <FormattedMessage
                        id="signup.createAccount.option.text"
                        defaultMessage="Or sign up with:"
                      />
                    </TextSignupWith>

                    <ButtonContainerSN>
                      <FacebookButton
                        PromoCode={PromoCode}
                        wantsFree={wantsFree}
                        disabled={!planSelected}
                        buttonType="signupapp"
                      />
                    </ButtonContainerSN>

                    <ButtonContainerSN>
                      <AppleButton wantsFree={wantsFree} buttonType="signup" />
                    </ButtonContainerSN>
                  </ContainerSignUpOptions>
                </ContainerSignUp>
              </ContentSection>
            </MainGrid>
            <LegalAccept>
              <FormattedMessage
                id="onboarding.creteAccount.acceptAllTerms"
                defaultMessage="By registering, you are accepting: <terms>Terms of Service</terms>, <cookies>Cookies Policy</cookies>, <privacy>Privacy Policy</privacy>, <caPrivacy>CA Privacy Rights</caPrivacy> and <doNotSell>Do Not Sell My Information</doNotSell> of Social Piper, and you will be automatically registered to receive emails about new Social Piper products, best practices or special offers, until you opt out."
                values={{
                  terms: (...chunks) => <LegalLink target="_blank" href="https://legal.socialpiper.com/social-piper-terms-of-service-2020-07-31/">{chunks}</LegalLink>,
                  cookies: (...chunks) => <LegalLink target="_blank" href="https://legal.socialpiper.com/social-piper-cookie-policy-2020-08-03/">{chunks}</LegalLink>,
                  privacy: (...chunks) => <LegalLink target="_blank" href="https://legal.socialpiper.com/social-piper-privacy-policy-2020-08-03/">{chunks}</LegalLink>,
                  caPrivacy: (...chunks) => <LegalLink target="_blank" href="https://legal.socialpiper.com/social-piper-ca-privacy-policy-2020-08-03/">{chunks}</LegalLink>,
                  doNotSell: (...chunks) => <LegalLink target="_blank" href="https://legal.socialpiper.com/social-piper-do-not-sell-my-personal-information-2020-08-03/">{chunks}</LegalLink>,
                }}
              />
            </LegalAccept>
          </Container>
        </Layout>
      )}
    </Media>
  );
};

export default CreateAccount;
